import agent from '../../app/api/agent';

export const downloadHandoffMessage = 'Download requested. Check your browser’s downloads for progress. If it fails, click Download again.';

// Call directly from the click handler so the new tab retains the user gesture.
// Navigating outside the Shopify iframe lets the browser own the file transfer.
export async function downloadImportFile(queueId: number): Promise<void> {
    const tab = window.open('about:blank', '_blank');
    if (!tab) throw new Error('Allow pop-ups for PartFinder, then click Download again.');
    try {
        tab.opener = null;
        tab.document.title = 'PartFinder download';
        const referrer = tab.document.createElement('meta');
        referrer.name = 'referrer';
        referrer.content = 'no-referrer';
        tab.document.head.appendChild(referrer);
        tab.document.body.textContent = 'Preparing your download…';
        const { url } = await agent.Imports.downloadLink(queueId);
        if (tab.closed) throw new Error('The download tab was closed. Click Download again and leave it open until the download starts.');
        tab.document.body.textContent = `${downloadHandoffMessage} You can close this tab once the download starts.`;
        tab.location.replace(url);
    } catch (error) {
        tab.close();
        throw error;
    }
}
